// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2m7Jz","info":"Note_info__oPpha","note":"Note_note__1Sxdp","actions":"Note_actions__3LqPc"};